<script lang="ts">
  import RichText, { hasRichTextContent } from '$components/rich-text.svelte';
  import RadioButton from '$components/ui/radio-button.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { VariantsComparisonStoryblok } from '$types/bloks';

  export let content: VariantsComparisonStoryblok;

  $: variants = content.variants.map((v) => v.name);
  let selected = content.variants.map((v) => v.name)[0];
  $: doc = content.variants.find((c) => c.name === selected)?.content;
</script>

<div use:storyblokEditable={content} class="mx-auto max-w-2xl px-2">
  {#if content.title}
    <h3 class="mb-3 text-md font-semibold">{content.title}</h3>
  {/if}

  {#if !!variants?.length}
    <div class="flex gap-2 mb-4">
      {#each variants as variant}
        <RadioButton value={variant} label={variant} id={variant} bind:group={selected} />
      {/each}
    </div>
  {/if}

  {#if doc && hasRichTextContent(doc)}
    <div class="rounded-sm border border-primary/4 bg-primary/2 p-3">
      <RichText
        {doc}
        class={cn(
          '[&>h3+*]:mt-1',
          '[&>h3]:text-sm [&>h3]:font-semibold',
          '[&>p]:text-sm',
          '[&>*+p]:mt-1',
          '[&>*+.rich-text-metrics]:mt-3',
          '[&>.rich-text-metrics+p]:mt-3',
          '[&_:last-child.rich-text-metrics>ul]:border-b-0 [&_:last-child.rich-text-metrics>ul]:pb-0'
        )}
      />
    </div>
  {/if}
</div>
